<template>
    <div class="invoice-address">
        <InvoiceAddress></InvoiceAddress>
    </div>
</template>

<script>
import InvoiceAddress from '../../components/address/InvoiveAddress.vue';

export default {
    name: 'invoice-address',
    components: {
        InvoiceAddress,
    },
};
</script>

<style lang="less" scoped>
</style>